import { render, staticRenderFns } from "./Unilateral-task-detail.vue?vue&type=template&id=0802f0fa&"
import script from "./Unilateral-task-detail.vue?vue&type=script&lang=js&"
export * from "./Unilateral-task-detail.vue?vue&type=script&lang=js&"
import style0 from "./Unilateral-task-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports